.customer-organization-form__company-info__company-info-inputs-container {
  width: 360px;
}
